import React, { useMemo }  from 'react'
import DataTableStatic from 'components/organisms/data-table-static'
import customerOrderItemTableColumns from 'domains/customer-order/molecules/item-table-columns'
import PropTypes from 'prop-types'

const propTypes = {
  data                   : PropTypes.array,
  refundItems            : PropTypes.array,
  handleClickAddToRefund : PropTypes.func
}

const defaultProps = {
  data                   : [],
  handleClickAddToRefund : () => {}
}

/**
 * @param {Array<Object>} data - array of order items objects
 * @param {Array<Object>} refundItems - array of selected order items objects that will be refunded
 * @param {Array<Object>} handleClickAddToRefund - function for handle click action `Add to Refund` button
 */
const CustomerOrderItemListTable = ({
  data,
  handleClickAddToRefund
}) => {

  /**
   * It's important that we're using React.useMemo
   * here to ensure that our data isn't recreated on every render.
   * see https://react-table.tanstack.com/docs/quick-start
   *  */
  const columns = useMemo(() => customerOrderItemTableColumns({ handleClickAddToRefund }), [ handleClickAddToRefund ])

  return (
    <DataTableStatic
      data={ data }
      columns={ columns }
    />
  )
}

CustomerOrderItemListTable.propTypes    = propTypes
CustomerOrderItemListTable.defaultProps = defaultProps

export default CustomerOrderItemListTable